<div
  class="mg-avatar-cluster"
  [ngClass]="'srcs-count-' + items.length">
  <mg-avatar
    *ngFor="let item of items"
    [src]="item.src"
    [color]="item.color"
    [personHash]="item.personHash || ''"></mg-avatar>
</div>
